import * as types from "@/store/mutation-types";

const state = {
  defaultPageSize: 10,
  leftDrawer: false,
  pageLoading: false,
  pageSubtitle: "",
  pageTitle: "",
  redirectTo: {}
};

export const getters = {
  pageLoading: state => {
    return state.pageLoading;
  },
  redirectTo: state => {
    return state.redirectTo;
  },
  defaultPageSize: state => {
    return state.defaultPageSize;
  },
  pageSubtitle: state => {
    return state.pageSubtitle;
  },
  pageTitle: state => {
    return state.pageTitle;
  },
  leftDrawer: state => {
    return state.leftDrawer;
  }
};

export const actions = {
  setDefaultPageSize({ commit }, size) {
    commit(types.SET_DEFAULT_PAGE_SIZE, size);
  },
  setPageTitle({ commit }, pageTitle) {
    if (typeof pageTitle === "string") {
      commit(types.SET_PAGE_TITLE, pageTitle);
      commit(types.SET_PAGE_SUBTITLE, "");
    }
    if (typeof pageTitle === "object") {
      commit(types.SET_PAGE_TITLE, pageTitle.pageTitle || "");
      commit(types.SET_PAGE_SUBTITLE, pageTitle.pageSubtitle || "");
    }
  },
  setLeftDrawer({ commit }, open) {
    commit(types.SET_LEFT_DRAWER, open);
  }
};

export const mutations = {
  [types.SET_DEFAULT_PAGE_SIZE](state, size) {
    state.defaultPageSize = size;
  },
  [types.SET_LEFT_DRAWER](state, leftDrawer) {
    state.leftDrawer = leftDrawer;
  },
  [types.SET_PAGE_SUBTITLE](state, pageSubtitle) {
    state.pageSubtitle = pageSubtitle;
  },
  [types.SET_PAGE_TITLE](state, pageTitle) {
    state.pageTitle = pageTitle;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
